import { ColumnDef } from "@tanstack/react-table";

import { Employee } from "./schema";
// import { DataTableRowActions } from "./data-table-row-actions";
import { DataTableColumnHeader } from "./data-table-column-header";
import { Badge } from "@/components/ui/badge/badge";
import { DataTableRowActions } from "./data-table-row-actions";

export const columns: ColumnDef<Employee, any>[] = [
  {
    accessorKey: "id",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Index" />
    ),
    cell: ({ row }) => <div className="w-[80px]">{row.index + 1}</div>,
    enableSorting: false,
    enableHiding: false,
  },
  {
    accessorKey: "name",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Name" />
    ),
    cell: ({ row }) => <div>{row.getValue("name")}</div>,
    enableColumnFilter: true,
  },
  {
    accessorKey: "email",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Email" />
    ),
    cell: ({ row }) => <div>{row.getValue("email")}</div>,
  },
  {
    accessorKey: "phone",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Phone" />
    ),
    cell: ({ row }) => <div>{row.getValue("phone")}</div>,
  },
  {
    accessorKey: "managedBy",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Managed By" />
    ),
    cell: ({ row }) => {
      const managedBy = row.getValue("managedBy") as { name: string } | null;
      return (
        <Badge variant={managedBy ? "default" : "secondary"}>
          {managedBy?.name || "Unassigned"}
        </Badge>
      );
    },
    filterFn: (row, _id, filterValue) => {
      const managedBy = row.getValue("managedBy") as { name: string } | null;
      const name = managedBy?.name || "Unassigned";
      return name.toLowerCase().includes(String(filterValue).toLowerCase());
    },
  },
  {
    accessorKey: "blocked",
    header: ({ column }) => (
      <DataTableColumnHeader column={column} title="Status" />
    ),
    cell: ({ row }) => (
      <Badge>{row.getValue("blocked") ? "Blocked" : "Not blocked"}</Badge>
    ),
  },

  {
    id: "actions",
    cell: ({ row }) => <DataTableRowActions row={row} />,
  },
];
